import React from "react"
import {Link as MuiLink, Table, TableBody, TableCell, TableRow, Box, Chip, Tooltip} from "@mui/material"
import {format} from "date-fns"

import {CustomerSearchResult, HistoricMatch} from "@indebted/api"
import {SystemOfRecordChip} from "@indebted/components/SystemOfRecordChip"

type CustomerResultsTableProps = {
	customers: CustomerSearchResult[]
	onRowClick: (customer: CustomerSearchResult) => void
}

// historicMatchTooltip describes why a row matched on a removed contact value.
// The value arrives already PII-obscured from the backend, so it is used as-is.
// Exported for unit testing.
function historicMatchTooltip(match: HistoricMatch): string {
	const removedAt = new Date(match.removedAt)
	const when = isNaN(removedAt.getTime()) ? "" : ` on ${format(removedAt, "d MMM yyyy")}`
	const removedBy = match.removedSource === "customer" ? `removed by customer${when}` : `removed${when}`
	return `Matched on a previously-known ${match.field} (${match.value}) — ${removedBy}`
}

function CustomerResultsTable({customers, onRowClick}: CustomerResultsTableProps) {
	return (
		<Table>
			<TableBody>
				{customers.map((customer) => (
					<TableRow key={customer.ID} style={{cursor: "pointer"}} onClick={() => onRowClick(customer)}>
						<TableCell>
							<Box display="flex" alignItems="center">
								<MuiLink component="span">{customer.FullName}</MuiLink>
								<SystemOfRecordChip systemOfRecord={customer.SystemOfRecord} />
								{customer.CollectionHold && (
									<Chip
										label="Collections on hold"
										size="medium"
										sx={{
											backgroundColor: "#E67E22",
											color: "#FFFFFF",
											border: "none",
											marginLeft: 2,
										}}
									/>
								)}
								{customer.historicMatch && (
									<Tooltip title={historicMatchTooltip(customer.historicMatch)}>
										<Chip
											label="Historic match"
											size="small"
											color="warning"
											variant="outlined"
											sx={{marginLeft: 2}}
										/>
									</Tooltip>
								)}
							</Box>
						</TableCell>
						<TableCell align="left">{customer.DOB}</TableCell>
						<TableCell align="right">{customer.ClientName}</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	)
}

export {CustomerResultsTable, historicMatchTooltip}
export type {CustomerResultsTableProps}
